// extracted by mini-css-extract-plugin
export default {"buttonBase":"PlusIconButton_buttonBase__Ru7AH","iconButton":"PlusIconButton_iconButton__igNzo"};